import React from 'react';
import PropTypes from 'prop-types';
import Title from '../title/Title.jsx';
import AddToListIcon from '../icons/AddToList.icon';
import Box from '../box/Box';
import {AppRouters} from '../../../settings';
import {Link} from '@reach/router';
import TableBox from '../box/TableBox';

export const RequestReports = props => {
  return (
    // hack to fix SVG overlapping when vertical height is smaller than container
    <TableBox>
      <Box className="p-3" borderBox={false}>
        <AddToListIcon/>
        <div>
          <Title className="pt-4 pb-2 text-center">¡Solicite Reportes!</Title>
          <p className="text-center">Obtenga el historial completo de su vehículo.</p>
        </div>
        <div className="d-flex">
          <Link to={AppRouters.newReport} className="btn btn-primary m-3 form-control">
            <span>Solicitar Reporte</span>
          </Link>
        </div>
      </Box>
    </TableBox>
  );
};

RequestReports.propTypes = {
  onRequest: PropTypes.func
};
export default RequestReports;
